var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cva } from 'class-variance-authority';
import { motionPresets } from './motion/presets';
import { classNames as cn } from './utils';
const tooltipVariants = cva([
    motionPresets.tooltip,
    motionPresets.popover,
    'z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance',
], {
    variants: {
        variant: {
            default: 'bg-base-800 text-text-inverse dark:bg-base-300 dark:text-base-900',
            white: 'bg-popover text-popover-foreground shadow-lg',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
const arrowVariants = cva('z-50 size-2.5 translate-y-[calc(-50%-2px)] rotate-45 rounded-xs', {
    variants: {
        variant: {
            default: 'bg-base-800 fill-base-800 dark:bg-base-300 dark:fill-base-300',
            white: 'bg-popover fill-popover',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
const TOOLTIP_DELAY_MS = {
    identification: 100,
    helper: 600,
};
function TooltipProvider(_a) {
    var props = __rest(_a, []);
    return _jsx(TooltipPrimitive.Provider, Object.assign({ "data-slot": "tooltip-provider" }, props));
}
function Tooltip(_a) {
    var { delay } = _a, props = __rest(_a, ["delay"]);
    return (_jsx(TooltipProvider, { delayDuration: TOOLTIP_DELAY_MS[delay], children: _jsx(TooltipPrimitive.Root, Object.assign({ "data-slot": "tooltip" }, props)) }));
}
function TooltipTrigger(_a) {
    var props = __rest(_a, []);
    return _jsx(TooltipPrimitive.Trigger, Object.assign({ "data-slot": "tooltip-trigger" }, props));
}
function TooltipContent(_a) {
    var { className, sideOffset = 0, variant, children, portalContainer, hideArrow } = _a, props = __rest(_a, ["className", "sideOffset", "variant", "children", "portalContainer", "hideArrow"]);
    return (_jsx(TooltipPrimitive.Portal, { container: portalContainer, children: _jsxs(TooltipPrimitive.Content, Object.assign({ "data-slot": "tooltip-content", sideOffset: sideOffset, className: cn(tooltipVariants({ variant }), className) }, props, { children: [children, !hideArrow && (_jsx(TooltipPrimitive.Arrow, { className: arrowVariants({ variant }) }))] })) }));
}
export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
